var map = {
	"./OwU.png": 3909,
	"./UwU2.png": 4555,
	"./Uwu4.png": 5654,
	"./associatedCommunities.png": 1819,
	"./been.png": 6007,
	"./bill.png": 9615,
	"./bwill.png": 9080,
	"./bwin.png": 7037,
	"./called.png": 1078,
	"./cawd.png": 363,
	"./consonantdeletion.png": 9475,
	"./free.png": 6672,
	"./fwi.png": 3116,
	"./insertion.png": 3555,
	"./itreplacement.png": 3189,
	"./little.png": 2552,
	"./owo.png": 348,
	"./registerDescriptor.png": 9868,
	"./respondantCommunities.png": 4267,
	"./respondantPerceptions.png": 3942,
	"./rlreplacement.png": 1607,
	"./uWu3.png": 9998,
	"./uwU5.png": 9336,
	"./uwu.png": 7313,
	"./uwumoon.png": 1504,
	"./uwusun.png": 8468,
	"./wet.png": 5133,
	"./wittle.png": 2512,
	"./ÒwÓ.png": 1046,
	"./ÚwÚ.png": 9801
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5837;